import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

/** User notification inbox, read state, and push-token operations. */
export class NotificationService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getMyAll(params = {}) {
        try {
            return await withRetry(
                () => this.api.getMyAll(params),
                { maxRetries: 2 },
            );
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch notifications');
        }
    }

    async markAsRead(id) {
        try {
            return await this.api.markAsRead(id);
        } catch (error) {
            throw this._handleError(error, 'Failed to mark as read');
        }
    }

    async markAllAsRead() {
        try {
            return await this.api.markAllAsRead();
        } catch (error) {
            throw this._handleError(error, 'Failed to mark all as read');
        }
    }

    async registerPushToken(token) {
        try {
            return await this.api.registerPushToken(token);
        } catch (error) {
            throw this._handleError(error, 'Failed to register notification token');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
